<template>
    <div>
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
			<div class="cw-content-nosidenav">
				<!-- ***** start custom content ***** -->
				<h1>Registration</h1>

                <HydroAgreementWord />

                <div class="form-row mb-4">
                    <div class="col-12 col-sm-4">
                        <label for="firstName"><span>First name</span></label>
                        <input autocomplete="off" type="text" v-model="firstName" id="firstName" class="form-control form-control-md" :disabled="fromLink" />
                    </div>
                    <div class="col-12 col-sm-4">
                        <label for="lastName"><span>Last name</span></label>
                        <input autocomplete="off" type="text" v-model="lastName" id="lastName" class="form-control form-control-md" :disabled="fromLink" />
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-sm-4">
                        <label for="jobTitle"><span>Job title</span></label>
                        <input autocomplete="off" type="text" v-model="jobTitle" id="jobTitle" class="form-control form-control-md" :disabled="fromLink" />
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-sm-4">
                        <label for="company"><span>Company</span></label>
                        <input autocomplete="off" type="text" v-model="company" id="company" class="form-control form-control-md" :disabled="fromLink" />
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-sm-4">
                        <label for="date">Date</label>
                        <div class="input-group">
                            <input id="date" readonly v-model="date" type="text" class="form-control form-control-md"  :disabled="fromLink" />
                        </div>
                    </div>
                </div>
                <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" value="true" v-model="agree" class="custom-control-input" id="customCheck1" :disabled="fromLink" />
                    <label class="custom-control-label" for="customCheck1">I agree</label>
                </div>
                <div class="row mt-5" v-if="!fromLink">
                    <div class="col">
                        <button type="button" class="btn btn-outline-secondary" @click="prevpage">Previous page</button>
                    </div>
                    <div class="col-auto">
                        <button type="button" :disabled="!agree" class="btn btn-primary float-right" @click="nextpage">{{buttonLabel}}</button>
                    </div>
                </div>
            </div>
			</main>
		</div>

    <!-- add before this -->
    </div>
</template>

<script>
    import HydroAgreementWord from '@/components/Wording/HydroAgreement';

	export default {
        name: 'hydro-agreement',
        components: {
            HydroAgreementWord
        },
        data: function () {
            return {
                firstName: "",
                lastName: "",
                jobTitle: "",
                company: "",
                date: new Date().toISOString().slice(0, 10),
                agree: false,
                buttonLabel: "View summary"
            }
        },
        created() {

            const data = (this.$route.params.data) 
                        ? JSON.parse(atob(this.$route.params.data)) 
                        : this.$store.getters.HYDRO;
                //let data = this.$store.getters.HYDRO;
            if( data.length > 0 ){
                const item = data[0];
                this.firstName = item.firstName;
                this.lastName = item.lastName;
                this.jobTitle = item.jobTitle;
                this.company = item.company;
                this.date = item.date;
                this.agree = item.agree;
            }
        },
        
        computed: {
            fromLink() {
                return (this.$route.params.data !== undefined);
            },
        },

        methods: {
            prevpage() {
                let nextPage = "Detail";

                this.$router.push({ name: nextPage });
            },
            nextpage() {
                let nextPage = "Summary";    

                let summaryPage = this.$store.getters.SUMMARYPAGE;
                if( summaryPage )
                    nextPage = "Summary";

                if (this.firstName === "") {
                    alert("First name is mandatory.");
                    return false;
                }
                if (this.lastName === "") {
                    alert("Last name is mandatory.");
                    return false;
                }
                if (this.jobTitle === "") {
                    alert("Job title is mandatory.");
                    return false;
                }
                if (this.company === "") {
                    alert("Company is mandatory.");
                    return false;
                }

                let value = { agree: this.agree, firstName: this.firstName,
                    lastName: this.lastName, jobTitle: this.jobTitle,
                    company: this.company, date: this.date
                };

                this.$store.dispatch("SAVE_HYDRO", value);

                this.$router.push({ name: nextPage });
            }
        }
	}
</script>